_ref2$isOwner